import React, { FC } from 'react';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import clsx from 'clsx';

interface AtGlanceCardProps {
  image: string;
  title: string;
}

const AtGlanceCard: FC<AtGlanceCardProps> = (props) => {
  const { image, title } = props;
  const theme = useTheme();
  const styles = createStyles(theme, image);

  return (
    <div className={styles.root}>
      <div className={styles.image} />
      <div className={clsx(styles.bottom)}>
        <p className={styles.title}>{title}</p>
      </div>
    </div>
  );
};

const createStyles = (theme: Theme, image: string) => ({
  root: css`
    display: flex;
    border-radius: 6px;
    border: 1px #E5E9EB solid;
    margin-bottom: 32px;
    width: 390px;
  `,
  image: css`
    background: #F7EDC7 url(${image}) no-repeat;
    background-size: cover;
    border-radius: 6px;
    height: 78px;
    width: 78px;
  `,
  bottom: css`
    display: flex;
    align-items: center;
  `,
  title: css`
    color: #303940;
    font-weight: 700;
    font-size: 18px;
    line-height: 32px;
    padding-left: 24px;
    ${theme.breakpoints.mobile.down} {
      font-size: 16px;
      line-height: 24px;
      padding-left: 12px;
    }
  `
});

export default AtGlanceCard;